<template>
  <v-tabs color="primary"  v-model="activeTabId">
    <v-tab>General</v-tab>
    <v-tab>Programs</v-tab>
    <v-tab @click="getAdditionalData('campaigns')">Campaigns</v-tab>
    <v-tab >Settings</v-tab>
    <v-tab @click="getAdditionalData('history')">History</v-tab>
    <v-tab @click="getNotes()">Notes</v-tab>

    <v-tab-item :key="`offer-${item.data.id}-general`">
      <v-container fluid>
        <v-row align="center">
          <v-col cols="12" sm="6" class="py-0">
            <v-row align="center" class="mt-0">
              <v-col cols="12" md="6">
                <v-text-field label="Name" readonly hide-details :value="item.data.name">
                  <template v-slot:append-outer>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            color="primary"
                            v-bind="attrs"
                            v-on="on"
                            target="_blank"
                            :disabled="!user[0].can('manage_offers')"
                            icon
                            class="text-decoration-none"
                            :to="`/advertisers/offerV2/${item.data.id}`"
                        >
                          <v-icon>mdi-open-in-new</v-icon>
                        </v-btn>
                      </template>
                      <span>Open Offer In New Window</span>
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row align="center" class="mt-0">
              <v-col cols="12" md="6">
                <v-text-field label="Advertiser" readonly hide-details :value="item.data.advertiserName">
                  <template v-slot:append-outer>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            color="primary"
                            v-bind="attrs"
                            v-on="on"
                            icon
                            @click="onAdvertiserPage"
                        >
                          <v-icon>mdi-briefcase-account</v-icon>
                        </v-btn>
                      </template>
                      <span>Open Advertiser Card</span>
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row align="center" class="mt-0">
              <v-col cols="12" md="6">
                <v-select hide-details label="Vertical"
                          ref="verticalId"
                          :items="this.verticals"
                          v-model="verticalId"
                          :disabled="!user[0].can('manage_offers')"
                ></v-select>
              </v-col>
            </v-row>
            <v-row align="center" class="mt-0">
              <v-col cols="12" md="6">
                <v-select hide-details label="Type"
                          red="type"
                          :items="[
                              {value: 'cpi', text: 'cpi'},
                              {value: 'cpc', text: 'cpc'},
                              {value: 'cpa', text: 'cpa'},
                              {value: 'cpr', text: 'cpr'},
                              {value: 'cps', text: 'cps'},
                          ]"
                          v-model="conversionType"
                          :disabled="!user[0].can('manage_offers')"
                ></v-select>
              </v-col>
            </v-row>
            <v-row align="center" class="mt-0">
              <v-col cols="12" md="6">
                <v-text-field label="Manager" readonly hide-details :value="item.data.managerName || 'not assigned' "></v-text-field>
              </v-col>
            </v-row>
            <v-row align="center" class="mt-0">
              <v-col cols="12" md="6">
                <v-text-field
                    label="External ID"
                    v-model="externalId"
                    hide-details
                    :value="item.data.externalId || '' "
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row align="center" class="mt-0">
              <v-col cols="12" md="6">
                <v-text-field
                    label="Affiliate Multi Pings"
                    type="number"
                    min="1"
                    hide-details
                    v-model.number="affiliateMultiPings"
                    :disabled="!user[0].can('manage_offers')"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="6" class="py-0">
            <v-row align="center" class="mt-0">
              <v-col cols="12" md="6">
                <v-text-field label="Currency"  readonly hide-details :value="item.data.currencyName"></v-text-field>
              </v-col>
            </v-row>
            <v-row align="center" class="mt-0">
              <v-col cols="12" md="6">
                <v-row class="align-end ma-0">
                  <v-text-field
                      label="Active Program"
                      disabled
                      hide-details
                      :value="activeProgram ? activeProgram.name : 'No Program'"
                  />
                  <v-btn color="primary" :disabled="false" text x-small @click="redirectToProgramsTab">
                    <v-icon>
                      mdi-tag
                    </v-icon>
                  </v-btn>
                </v-row>
              </v-col>
            </v-row>
            <v-row align="center" class="mt-0">
            </v-row>
            <v-row align="center" class="mt-0">
              <v-col cols="12" md="6">
                <v-select hide-details label="Status"
                          ref="status"
                          :items="[{value: 'private', text: 'Private'}, {value: 'apply_to_run', text: 'Apply to run'},
                                  {value: 'public', text: 'Public'}, {value: 'inactive', text: 'Inactive'},
                                  {value: 'draft', text: 'Draft'}]"
                          v-model="status"
                          :disabled="item.data.type === 'aggregated' && this.getOffersAggregated.length === 0 || !user[0].can('manage_offers')"
                          :readonly="!user[0].can('manage_offers')"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">

                <v-text-field
                    v-if="item.data.type !== 'aggregated'"
                    label="Landing Page"
                    v-model="landingPage"
                    hide-details
                    ref="landingPage"
                    :disabled="!user[0].can('manage_offers')"
                >
                </v-text-field>

                <v-text-field
                    v-else
                    label="Landing Page"
                    :append-outer-icon="'mdi-briefcase-account'"
                    @click:append-outer="onLandingPageDetails"
                    :value="getAggregatedOfferFirstLP()"
                    readonly
                >
                  <template slot="append" v-if="this.getOffersAggregated.length !==0">
                    <v-avatar
                        color="primary"
                        size="26"
                    >+{{this.getOffersAggregated.length}}</v-avatar>
                  </template>
                </v-text-field>

                <v-switch :disabled="!user[0].can('manage_featured_offer')" class="switch-ftr" label="Featured" v-model="featured" @change="setFeatured"></v-switch>

              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-btn
            v-if="!checkInputsNotChanged() && user[0].can('manage_offers')"
            fixed
            top
            right
            style="top: 50px"
            color="primary"
            :loading="updating"
            :disabled="updating"
            class="upd-btn ma-0"
            @click="onUpdate"
        >
          Update
        </v-btn>
        <v-row>
          <v-col cols="12" md="3" class="pb-0">
            <v-select hide-details label="Trends" v-model="chartOptions.chartPeriod" :items="[{value: 7, text: 'Last 7 Days'}]"></v-select>
          </v-col>
          <v-col cols="12" class="py-0">
            <v-skeleton-loader :loading="chartLoading" class="mx-auto mt-3" width="100%" height="250px" type="image">
              <apexchart type="line" height="250px" :options="chartOptions"  :series="series"></apexchart>
            </v-skeleton-loader>
          </v-col>
        </v-row>
      </v-container>
    </v-tab-item>
    <v-tab-item>
      <v-container fluid>
        <v-row no-gutters>
          <v-col cols="5">
            <v-select
                hide-details
                :disabled="!user[0].can('assign_programs')"
                label="Available Program"
                v-model="activeProgramId"
                :items="programsPrepared"
            />
          </v-col>
          <v-col cols="1" class="download">
            <span class="mr-3 primary-color" @click="download(activeProgramId)">
              <i class="fas fa-download"></i>
            </span>
          </v-col>
          <v-spacer />
          <v-col cols="5" class="d-flex align-center justify-end text-right">
            <a v-if="user[0].can('create_programs')" class="new-program">
              <b>Need a new program?</b>
              <v-icon>mdi-open-in-new</v-icon>
            </a>
          </v-col>
          <v-col cols="12">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-center">
                    Code
                  </th>
                  <th class="text-center">
                    Geo
                  </th>
                  <th class="text-center">
                    Payout (USD)
                  </th>
                  <th v-if="user[0].can('see_profit')" class="text-center">
                    Price (USD)
                  </th>
                  <th v-if="user[0].can('see_profit')" class="text-center">
                    Margin
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="(program, index) in preparedProgramsForTable"
                    :key="index"
                >
                  <td class="text-center">{{ program.geo }}</td>
                  <td class="text-center">{{ program.countryName }}</td>
                  <td class="text-center">{{ program.payout }}</td>
                  <td v-if="user[0].can('see_profit')" class="text-center">{{ program.price }}</td>
                  <td v-if="user[0].can('see_profit')" class="text-center">{{ program.margin }}</td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
        <v-btn
            v-if="programUpdateButtonVisible"
            fixed
            top
            right
            style="top: 50px"
            color="primary"
            class="upd-btn ma-0"
            @click="onUpdate()"
        >
          Update
        </v-btn>
      </v-container>
    </v-tab-item>
    <v-tab-item :key="`offer-${item.data.id}-campaigns`">
      <v-data-table
          :headers="headers.campaigns"
          :items="campaigns"
          :loading="isCampaignsLoading"
          fixed-header
          loading-text="Loading... Please wait"
          color="#7F98A5"
      >
        <template v-slot:item.name="{ item }">
          <span class="campaign-item" v-if="user[0].can('manage_campaigns')" @click="openCampaignCard(item)">{{ item.name }}</span>
          <span v-else>{{ item.name }}</span>
        </template>
      </v-data-table>
    </v-tab-item>
    <v-tab-item :key="`offer-${item.data.id}-settings`">
      <VariantManager :variants="this.getOfferVariants" :offerId="item.data.id" />
    </v-tab-item>
    <v-tab-item :key="`offer-${item.data.id}-history`">
      <v-data-table
              :headers="headers.logs"
              :items="logs"
              :loading="isLogsLoading"
              fixed-header
              loading-text="Loading... Please wait"
              color="#7F98A5"
      >
        <template v-slot:item.logs="{ item }" >
          <HistoryLog :logsString='item.logs' ></HistoryLog>
        </template>
      </v-data-table>
    </v-tab-item>
    <v-tab-item :key="`affiliate-${item.data.id}-note`">
      <v-progress-linear v-show="preloaderNotes"
                         indeterminate
      ></v-progress-linear>
      <v-container fluid class="pa-0">
        <div class="d-flex justify-space-between px-3 align-content-center">
          <h2 class="mb-0">Notes</h2>
          <OfferNotesCreate :offer="item.data" :user="user[0]" v-on:createNote="createNote"/>
        </div>
        <v-data-table
            :headers="headers.cardOfferNotes.offerNotes"
            :header-props="{ sortIcon: null, headerClass: 'white-space-no-wrap' }"
            :items="headers.cardOfferNotes.items"
            :footer-props="{itemsPerPageOptions: headers.cardOfferNotes.pageOptions}"
            :page="1"
            :items-per-page="25"
            loading-text="Loading... Please wait"
            fixed-header
            :class="`elevation-0 mb-0 co-data-table items-size-45`"
            item-class="td_title"
            color="secondary"
        >
          <template  v-slot:item.dateAdded="{ item }">
            {{item.dateAdded}}
            <div>
              <OfferNotesEdit :note="item" :user="user[0]" v-on:createNote="createNote"/>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <button
                      v-bind="attrs"
                      v-on="on"
                      @click="manageNote(item, 'delete')"
                      :disabled="user[0].email !== item.email"
                      class="td_title btn btn-link"
                  >
                    <i class="far fa-trash"></i>
                  </button>
                </template>
                <span>Delete Note</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </v-container>
    </v-tab-item>
    <Confirm ref="confirm"></Confirm>
  </v-tabs>

</template>

<script>
import {mapGetters, mapMutations, mapState} from 'vuex'
import reports from "@/api/reports";
import offers from "@/api/offers";
import offer from "@/api/offer";
import campaignsApi from "@/api/campaigns";
import { DateTime } from "luxon";
import store from '@/store';
import { createPeriod } from "@/helpers";
import Confirm from "@/components/common/Confirm";
import programs from "@/api/programs";
import HistoryLog from "@/components/common/HistoryLog";
import VariantManager from "@/components/pages/advertisers/offers/VariantManager.vue";
import offerNotes from "@/api/offerNotes";
import OfferNotesEdit  from "@/components/pages/advertisers/offers/OfferNotesEdit.vue";
import OfferNotesCreate  from "@/components/pages/advertisers/offers/OfferNotesCreate.vue";
import affiliatesApi from "@/api/affiliates";
import download from "@/helpers/download";

  export default {
    props: {
      item: {
        type: Object
      }
    },
    components: {
      OfferNotesEdit,OfferNotesCreate,
      VariantManager,
      Confirm,
      HistoryLog
    },
    async mounted() {
      if (this.item.data.type === 'aggregated'){
        await this.$store.dispatch('offer/saveOfferAggregatedStore', this.item.data.id)
      }
      await this.$store.dispatch('offer/saveOfferVariantsStore', this.item.data.id)
      await this.getOfferSales();
      if (!this.getVerticals || !this.getVerticals.length) {
        await this.$store.dispatch('verticals/saveVerticalsStore');
      }
      this.verticals = this.getVerticals.map(vertical => ({ value: vertical.id, text: vertical.name}))

      this.programList = await programs.getProgramsList();
      const allowedCountries = await programs.getAllowedCountriesByOfferId(this.item.data.id);

      this.allowedCountries = allowedCountries.countries || [];
      await this.fetchProgramData();


    },
    watch: {
      async activeProgramId() {
        const allowCountries = this.allowedCountries
        const programDetails = await programs.getProgramDetails(this.activeProgramId);
        if (allowCountries.length !== 0) {
          this.programDetails = programDetails.filter(detail => allowCountries.includes(detail.geo));
        } else {
          this.programDetails = programDetails;
        }
        this.tempIndex = 0;
        this.$forceUpdate();
      },
    },
    methods: {
      async createNote() {
        await this.getNotes();
      },
      async manageNote(note, action) {
        if (action === 'delete') {
          await offerNotes.updateOfferNote({id: note.id, note: note.note, isDelete: true});
          await this.getNotes();
        }
      },
      async openCampaignCard(item) {

        const campaigns = await campaignsApi.getCampaignsData({
          payload: {
            showInactiveCampaigns: true,
            orderBy: 'dateAdded',
            orderDirectionAsc: false,
            page: 1,
            limit: 1,
            filters: {
              id: item.id
            }
          }
        });

        if (!campaigns || !campaigns.data || !campaigns.data.length) {
          return;
        }

        const campaign = campaigns.data[0];

        store.dispatch('cards/ADD', {
          type: 'campaign',
          title: `[${campaign.id}] - [${campaign.name}] : [${campaign.status}]`,
          key: `campaign-${campaign.id}`,
          data: campaign
        })
      },
      async setFeatured() {
        if (this.featured && (this.featured !== this.item.data.featured)) {
          this.shouldSendNotification = await this.$refs.confirm.open('', 'Should notifications be sent to affiliates?', { color: 'blue' });
        }
      },
      redirectToProgramsTab () {
        this.activeTabId = 1;
      },
      async getOfferSales() {
        this.chartLoading = true;
        const period = {
          fromDate: DateTime.utc().startOf('day').minus({days: this.chartOptions.chartPeriod}).toSeconds(),
          toDate: DateTime.utc().startOf('day').toSeconds()
        };
        const filter = [{field: 'offer_id', value: [this.item.data.id]}];
        const params = {
          entity: 'day',
          select: ['day', 'conversions'],
          filter: filter,
          ...period,
          groupBy: 'day',
          orderBy: 'day',
          orderDirectionAsc: false,
          page: 1,
          limit: 100,
          isChart: true,
        };
        const result = await reports.getDrillDownReports(params);

        const { dates, conversions } = createPeriod(result, this.chartOptions.chartPeriod);

        this.chartOptions = {...this.chartOptions, ...{
            xaxis: {
              categories: dates
            }
          }};

        this.series = [{
          data: conversions
        }];
        this.chartLoading = false
        // this.preloaderChart = false
      },
      async getNotes() {
        this.preloaderNotes = true;
        try {
          const notes  = await offerNotes.getOfferNotesList(this.item.data.id);
          this.headers.cardOfferNotes.items = notes
        } catch (e) {
          console.error(e);
          store.dispatch('alert/ALERT_ERROR', `An error has occurred.`, {root: true});
        }
        this.preloaderNotes = false;
      },
      async getAdditionalData(tabName) {
        if (tabName === 'affiliates' && !this.affiliates.length) {
          this.affiliates = await offers.getAffiliates(this.item.data);
          this.isAffiliatesLoading = false;
        }
        if (tabName === 'campaigns' && !this.campaigns.length) {
          this.campaigns = await offers.getCampaigns(this.item.data);
          this.isCampaignsLoading = false;
        }
        if (tabName === 'history' && !this.logs.length) {
          let rowLogs = await offers.getHistory(this.item.data);
          this.logs = rowLogs.map( log => ({
            ...log, dateAdded: (new Date(log.dateAdded*1000)).toLocaleDateString("en-US")
          }));
          this.isLogsLoading = false;
        }
      },

      checkInputsNotChanged() {
        return this.verticalId == this.item.data.verticalId &&
               this.conversionType ==  this.item.data.conversionType &&
               this.status == this.item.data.status &&
               this.landingPage == this.item.data.landingPageUrl &&
               this.payIn == this.item.data.payIn &&
               this.payOut == this.item.data.payOut &&
               this.featured === this.item.data.featured &&
               this.externalId === this.item.data.externalId &&
               this.affiliateMultiPings == this.item.data.affiliateMultiPings
      },
      async fetchProgramData() {
        const activeProgramId = this.item.data.programId;
        const result = this.programList.find(value => value.id === activeProgramId);
        this.activeProgramId = result ? result.id : 1;
        this.activeProgram = result;
      },
      prepareProgramData(index, program = {}) {
        if (index === 0) {
          this.tempIndex = 0;

          let activeProgramData = {};
          this.programList.forEach(value => {
            if (value.id === this.activeProgramId) {
              activeProgramData = value
            }
          })
          if (activeProgramData.payout > 0) {
            let marginPercent = activeProgramData.marginType === 'fixed' ?
                    Math.round((1-activeProgramData.payout / activeProgramData.price) * 100)
                : activeProgramData.marginPercent;

            const defaultData = {
              code: 'WW',
              geo: 'Worldwide (Default)',
              price: activeProgramData.price,
              payout: activeProgramData.payout,
              margin: `${Math.round((activeProgramData.price - activeProgramData.payout) * 100) / 100} (${marginPercent}%)`,
              nextGeo: this.programDetails[this.tempIndex].countryName,
              nextCode: this.programDetails[this.tempIndex].geo,
              nextPrice: this.programDetails[this.tempIndex].price,
              nextPayout: this.programDetails[this.tempIndex].payout,
              nextMargin: this.programDetails[this.tempIndex].margin,
            };

            this.tempIndex++;
            return defaultData;
          }

        }

        const data = {};

        if (this.tempIndex < this.programDetails.length) {
          data['geo'] = this.programDetails[this.tempIndex].countryName;
          data['code'] = this.programDetails[this.tempIndex].geo;
          data['price'] = this.programDetails[this.tempIndex].price;
          data['payout'] = this.programDetails[this.tempIndex].payout;
          data['margin'] = this.programDetails[this.tempIndex].margin;
          this.tempIndex++;
        }

        if (this.tempIndex < this.programDetails.length) {
          data['nextGeo'] = this.programDetails[this.tempIndex].countryName;
          data['nextCode'] = this.programDetails[this.tempIndex].geo;
          data['nextPrice'] = this.programDetails[this.tempIndex].price;
          data['nextPayout'] = this.programDetails[this.tempIndex].payout;
          data['nextMargin'] = this.programDetails[this.tempIndex].margin;
          this.tempIndex++;
        }

        return data;
      },
      async onUpdate() {
        if(parseFloat(this.payIn) < parseFloat(this.payOut)) {
          const isConfirmed = await this.$refs.confirm.open('', 'PayOut is more than payIn. Is it correct?', { color: 'red' });
          if (!isConfirmed) {
            return
          }
        }

        this.updating = true;

        const updatedData = {
          id: this.item.data.id,
          verticalId: this.verticalId,
          conversionType: this.conversionType,
          status: this.status,
          payIn: this.payIn,
          payOut: this.payOut,
          programId: this.activeProgramId,
          landingPage: this.landingPage,
          landingPageId: this.item.data.landingPageId,
          featured: this.featured,
          shouldSendNotification: this.shouldSendNotification,
          externalId: this.externalId,
          affiliateMultiPings: this.affiliateMultiPings
        };

        const result = await offer.updateOffer(updatedData);
        this.updating = false;

        if (result) {
          store.dispatch('alert/ALERT_SUCCESS', `Offer has been updated`, {root: true});
          store.dispatch('cards/REMOVE', `offer-${this.item.data.id}`)
          await store.dispatch('offers/updateOffer', updatedData)
        } else {
          store.dispatch('alert/ALERT_ERROR', `An error has occurred.`, {root: true});
        }

        setTimeout(() => {
          store.dispatch('alert/ALERT_REMOVE', ``, {root: true});
        }, 3000);

      },
      getAggregatedOfferFirstLP(){
        let offersAggregated = this.getOffersAggregated
        return offersAggregated.length !== 0 && offersAggregated[0].landingPageUrl
      },

      async onLandingPageDetails(){
        if (this.item.data.type === 'aggregated'){
          store.dispatch('cards/ADD', {
            type: 'offerAggregatedLPCard',
            title: this.item.data.name,
            key: `offerAggregatedLPCard-${this.item.data.id}`,
            data: this.item.data
          })
        }
      },
      async onAdvertiserPage() {
        await store.dispatch('advertiser/getProfiles', {
          limit: 1,
          page: 1,
          orderBy: 'id',
          orderDirectionAsc: false,
          filters: {
            id: this.item.data.advertiserId
          }
        });
        const advertisers = this.profiles.data;

        const item = advertisers[0];
        store.dispatch('cards/ADD', {
          type: 'advertiser',
          title: item.name,
          key: `advertiser-${item.id}`,
          data: item
        })
      },
      download() {
        const geos = [];

        if (!this.preparedProgramsForTable || !Array.isArray(this.preparedProgramsForTable)) {
          return;
        }
        this.preparedProgramsForTable.forEach(item => {
          geos.push({
            geo: item.geo,
            payout: item.payout
          });
        });

        download(geos);
      }
    },
    computed:{
      ...mapState('user', ['user']),
      ...mapGetters('verticals', ['getVerticals']),
      ...mapGetters('advertiser', ['profiles']),
      ...mapGetters('offer', ['getOffersAggregated','getOfferVariants']),
      programsPrepared() {
        const tempProgramList = JSON.parse(JSON.stringify(this.programList));
        tempProgramList.map(program => {
          program['text'] =  program.name;
          program['value'] = program.id;
        });
        return tempProgramList;
      },
      preparedProgramsForTable() {
        const preparedProgramsForTable = [...this.programDetails];

        const activeProgramData = this.programList.find(value => value.id === this.activeProgramId) || {};

        const marginPercent = activeProgramData.payout === 0 ? 0
                : ((1 - (activeProgramData.payout / activeProgramData.price)) * 100).toFixed(2);

        const defaultData = {
          countryName: 'Worldwide (Default)',
          geo: 'WW',
          price: activeProgramData.price || 0,
          payout: activeProgramData.payout || 0,
          margin: `${(activeProgramData.price - activeProgramData.payout).toFixed(2)} (${marginPercent}%)`,
          nextGeo: '',
          nextCode: '',
          nextPrice: '',
          nextPayout: '',
          nextMargin: ''
        };

        if (activeProgramData.payout > 0){
          preparedProgramsForTable.unshift(defaultData);
        }

        return preparedProgramsForTable;
      },
      programUpdateButtonVisible() {
        return !this.activeProgram || this.activeProgram.id !== this.activeProgramId;
      }
    },
    name: "OfferCard",

    data() {
      return {
        activeTabId: 0,
        programUpdating: false,
        activeProgramId: null,
        programList: [],
        allowedCountries: [],
        programDetails: [],
        activeProgram: null,
        tempIndex: 0,
        updating: false,
        verticalId: this.item.data.verticalId,
        conversionType: this.item.data.conversionType,
        payIn: this.item.data.payIn,
        payOut: this.item.data.payOut,
        status: this.item.data.status,
        landingPage: this.item.data.landingPageUrl,
        featured: this.item.data.featured,
        shouldSendNotification: false,
        externalId: this.item.data.externalId,
        affiliateMultiPings: this.item.data.affiliateMultiPings || 1,
        affiliates: [],
        campaigns: [],
        logs: [],
        isAffiliatesLoading: true,
        isCampaignsLoading: true,
        isLogsLoading: true,
        preloaderNotes: true,
        headers: {
          campaigns: [
            {text: 'ID', align: 'start', sortable: false, value: 'id'},
            {text: 'Name', sortable: false, value: 'name'},
            {text: 'PayOut', sortable: false, value: 'payout'},
            {text: 'Campaign Status', sortable: false, value: 'status'},
            {text: 'Affiliate', sortable: false, value: 'affiliate'},
            {text: 'Affiliate Status', sortable: false, value: 'affiliateStatus'},

          ],
          logs: [
            {text: 'User', align: 'start', sortable: false, value: 'user'},
            {text: 'Action', sortable: false, value: 'action'},
            {text: 'Date', sortable: false, value: 'dateAdded'},
            {text: 'Logs', sortable: false, value: 'logs'},
          ],
          cardOfferNotes: {
            offerNotes:[
              {text: 'Author', value: 'author', class: 'color', align: 'center'},
              {text: 'Author Email', value: 'email', class: 'color', align: 'center'},
              {text: 'Note', value: 'note', class: 'color', align: 'center', cellClass:'noteCell'},
              {text: 'Date Added', value: 'dateAdded', align: 'center'},
            ],
            items: [],
            pageOptions: [10, 25, 50, 100],
          },

        },
        chartLoading: true,
        verticals: [],
        chartOptions: {
          chartPeriod: 7,
          chart: {
            id: `offer-${this.item.data.id}-chart`,
            toolbar: {
              tools: {
                download: true,
                selection: false,
                zoom: false,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: false
              }
            },
          },
          xaxis: {
            categories: []
          },
          colors: [this.$vuetify.theme.themes.light.primary],
        },
        series: [
          {
            name: 'Conversions',
            data: []
          },
        ],
      }
    }
  }
</script>

<style scoped lang="sass">
  .upd-btn
    margin: 2%
  .switch-ftr
    margin-top: 7% !important
  .campaign-item
    color: var(--v-primary-base) !important
    &:hover
      cursor: pointer
      text-decoration: underline
  .download
    margin-top: 30px
    margin-left: 15px
    &:hover
      cursor: pointer
</style>
